import client from "./client";

export default {
    async getBusinessSettings() {
        return client.parseResponse(await client.get('/business-settings'));
    },
    async updateBusinessSettings(data) {
        return client.parseResponse(await client.post('/business-settings', data));
    },
    async uploadBusinessLogo(file) {
        return client.parseResponse(await client.upload('/business-settings/logo', {logo: file}));
    },
    // Lightweight, non-owner-gated - any authenticated staff login can call
    // this (unlike getBusinessSettings above, which is owner-only), since
    // it's just the two cosmetic fields the sidebar needs on every page.
    async getMyBranding() {
        return client.parseResponse(await client.get('/my-business-branding'));
    },
}
